// extracted by mini-css-extract-plugin
export default {"arrow":"arrow_arrow__Rt6uf"};